/* eslint-disable jsx-a11y/anchor-is-valid */
import {useDispatch, useSelector} from 'react-redux'
import {Link, NavLink, useNavigate} from 'react-router-dom'
import {camelCaseToNormalCase, KTSVG} from '../../../../../_metronic/helpers'
import {GeneralDataOFLoginUser} from '../../../../Utils/Auth'
import {useState} from 'react'
import {
  getAllUserDetails,
  getAllUserCreditHistory,
} from '../../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'

export function Overview() {
  const dispatch = useDispatch()
  const userData: any = useSelector(getAllUserDetails)
  const userCreditHistory: any = useSelector(getAllUserCreditHistory)
  const navigate = useNavigate()

  const [page, setPage] = useState({
    page: 1,
    size: 10,
    type: {value: '', label: 'Select type'},
    campType: {value: '', label: 'Select transaction '},
  })

  return (
    <>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header cursor-pointer'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0 fs-2'>Profile Details</h3>
          </div>

          {userData?.role !== 'superAdmin' && (
            <Link to='/accounts/settings' className='btn btn-primary align-self-center'>
              Edit Profile
            </Link>
          )}
        </div>

        <div className='card-body p-9'>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Full Name</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>{GeneralDataOFLoginUser()?.name}</span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Company</label>

            <div className='col-lg-8 fv-row'>
              <span className='fw-bolder fs-6 text-dark'>
                {camelCaseToNormalCase(GeneralDataOFLoginUser()?.companyName)}
              </span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>
              Contact Phone
              <i
                className='fa fa-exclamation-circle ms-1 fs-7 '
                data-bs-toggle='tooltip'
                title='Phone number must be active'
              ></i>
            </label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>+{GeneralDataOFLoginUser()?.mobile}</span>
              {GeneralDataOFLoginUser()?.isMobileVerified ? (
                <span className='badge badge-success'>Verified</span>
              ) : (
                <span className='badge badge-danger'>Not-Verified</span>
              )}{' '}
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>
              Email
              <i
                className='fa fa-exclamation-circle ms-1 fs-7'
                data-bs-toggle='tooltip'
                title='Email must be active'
              ></i>
            </label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>{GeneralDataOFLoginUser()?.email}</span>
              {GeneralDataOFLoginUser()?.isEmailVerified ? (
                <span className='badge badge-success'>Verified</span>
              ) : (
                <span className='badge badge-danger'>Not-Verified</span>
              )}
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Company Site</label>

            <div className='col-lg-8'>
              <a
                href={GeneralDataOFLoginUser()?.companyWebsite}
                className='fw-bold fs-6 text-dark fw-bolder text-hover-primary'
              >
                {GeneralDataOFLoginUser()?.companyWebsite}
              </a>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>
              Country
              <i
                className='fa fa-exclamation-circle ms-1 fs-7'
                data-bs-toggle='tooltip'
                title='Country of origination'
              ></i>
            </label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>
                {GeneralDataOFLoginUser()?.isoCode === 'au' && 'Melbourne, Australia'}
              </span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Communication</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>
                {GeneralDataOFLoginUser()?.communication?.email && camelCaseToNormalCase('email, ')}
                {GeneralDataOFLoginUser()?.communication?.phone && camelCaseToNormalCase('phone')}
              </span>
            </div>
          </div>

          <div className='row mb-10'>
            <label className='col-lg-4 fw-bold text-muted'>Allow Changes</label>

            <div className='col-lg-8'>
              <span className='fw-bold fs-6'>Yes</span>
            </div>
          </div>

          {/* <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed p-6'>
            <KTSVG
              path='/media/icons/duotune/general/gen044.svg'
              className='svg-icon-2tx svg-icon-warning me-4'
            />
            <div className='d-flex flex-stack flex-grow-1'>
              <div className='fw-bold'>
                <h4 className='text-gray-800 fw-bolder'>We need your attention!</h4>
                <div className='fs-6 text-gray-600'>
                  Your payment was declined. To start using tools, please{' '}
                  <Link className='fw-bolder' to='/crafted/account/settings'>
                    Add Payment Method
                  </Link>
                  .
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>

      {
        true && <div></div>
        //  <div className='row gy-10 gx-xl-10'>
        //       <div className='col-xl-12'>
        //         <div className={`card creadit-historytable card-xxl-stretch mb-5 mb-xl-10`}>
        //           <div className='card-header border-0 pt-7 ms-3'>
        //             <h3 className='card-title align-items-start flex-column'>
        //               <span className='card-label fw-bolder fs-2 mb-1'>Credit History</span>
        //               <span className='text-muted mt-1 fw-bold fs-7'>order by the most recent</span>
        //             </h3>
        //             <div className='card-toolbar d-flex'>
        //               <Link to=''>
        //                 <a
        //                   href='#'
        //                   className='btn btn-sm btn-light-primary me-2 fw-500'
        //                   data-kt-menu-trigger='click'
        //                   data-kt-menu-attach='parent'
        //                   data-kt-menu-placement='bottom-end'
        //                   data-kt-menu-flip='bottom'
        //                 >
        //                   <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
        //                   Filter
        //                 </a>
        //                 <FilterPopper />
        //               </Link>

        //               <NavLink to={'topup'} className='btn btn-sm btn-primary fw-500'>
        //                 Top up
        //               </NavLink>
        //             </div>
        //           </div>
        //           <OverviewTable className={''} />
        //         </div>
        //       </div>
        //     </div>
      }
    </>
  )
}
